var HOVER_OPEN_MS = 280;
var HOVER_CLOSE_MS = 120;
/** Debug: `?tooltip-id=123` öffnet den Tooltip wie bei Hover (Post-ID = data-glossary-id). */
var TOOLTIP_DEBUG_PARAM = 'tooltip-id';
var popoverEl = null;
var hoverOpenTimer = null;
var hoverCloseTimer = null;
var activeTrigger = null;
/** Element, das aktuell anchor-name gesetzt hat (nur CSS-Anchor-Modus) */
var anchoredTriggerEl = null;
/** Entfernt anchor-name erst nach Leave-Animation; bei neuem Öffnen abbrechen */
var anchorRemovalTimer = null;
var ANCHOR_NAME_LEAVE_MS = 240;
function clearAnchorRemovalTimer() {
    if (anchorRemovalTimer !== null) {
        window.clearTimeout(anchorRemovalTimer);
        anchorRemovalTimer = null;
    }
}
/** CSS Anchor Positioning (position-anchor / anchor-name), siehe MDN */
function cssAnchorPositioningAvailable() {
    try {
        return (typeof CSS !== 'undefined' &&
            typeof CSS.supports === 'function' &&
            CSS.supports('position-anchor', 'none'));
    }
    catch (_a) {
        return false;
    }
}
var useCssAnchor = cssAnchorPositioningAvailable();
function getPopover() {
    if (!popoverEl) {
        popoverEl = document.createElement('div');
        popoverEl.id = 'glossary-tooltip-popover';
        popoverEl.setAttribute('role', 'tooltip');
        popoverEl.setAttribute('hidden', '');
        var inner = document.createElement('div');
        inner.className = 'glossary-tooltip__inner';
        popoverEl.appendChild(inner);
        popoverEl.addEventListener('mouseenter', function () { return clearTimers(); });
        popoverEl.addEventListener('mouseleave', function () { return scheduleHide(); });
        if (useCssAnchor) {
            popoverEl.classList.add('glossary-tooltip--anchor');
        }
        document.body.appendChild(popoverEl);
    }
    return popoverEl;
}
function clearTimers() {
    if (hoverOpenTimer) {
        clearTimeout(hoverOpenTimer);
        hoverOpenTimer = null;
    }
    if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
    }
}
/** Fallback ohne CSS Anchor: feste Koordinaten per getBoundingClientRect */
function positionPopoverJs(trigger) {
    var el = getPopover();
    var rect = trigger.getBoundingClientRect();
    var margin = 10;
    el.classList.remove('is-visible', 'glossary-tooltip--below');
    el.removeAttribute('hidden');
    el.style.visibility = 'hidden';
    el.style.left = '0';
    el.style.top = '0';
    var tipRect = el.getBoundingClientRect();
    var left = rect.left + rect.width / 2 - tipRect.width / 2;
    var maxLeft = window.innerWidth - tipRect.width - margin;
    left = Math.max(margin, Math.min(left, maxLeft));
    var spaceAbove = rect.top - margin;
    var top = rect.top + window.scrollY - tipRect.height - 12;
    if (spaceAbove < tipRect.height + 12) {
        top = rect.bottom + window.scrollY + 12;
        el.classList.add('glossary-tooltip--below');
    }
    el.style.setProperty('--g-arrow-left', "".concat(rect.left + rect.width / 2 - left, "px"));
    el.style.left = "".concat(left, "px");
    el.style.top = "".concat(top, "px");
    el.style.visibility = '';
    requestAnimationFrame(function () {
        el.classList.add('is-visible');
    });
}
/**
 * Position über CSS anchor-name / position-anchor (Browser mit Support).
 * https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Properties/position-anchor
 */
function positionPopoverCssAnchor(trigger) {
    var el = getPopover();
    clearAnchorRemovalTimer();
    if (anchoredTriggerEl && anchoredTriggerEl !== trigger) {
        anchoredTriggerEl.style.removeProperty('anchor-name');
    }
    anchoredTriggerEl = trigger;
    trigger.style.setProperty('anchor-name', '--cowp-glossary-active');
    el.classList.remove('is-visible', 'glossary-tooltip--below');
    el.style.left = '';
    el.style.top = '';
    el.style.visibility = 'hidden';
    var rect = trigger.getBoundingClientRect();
    var margin = 10;
    el.removeAttribute('hidden');
    void el.offsetWidth;
    var tipRect = el.getBoundingClientRect();
    var spaceAbove = rect.top - margin;
    if (spaceAbove < tipRect.height + 12) {
        el.classList.add('glossary-tooltip--below');
    }
    el.style.visibility = '';
    requestAnimationFrame(function () {
        el.classList.add('is-visible');
    });
}
function positionPopover(trigger) {
    if (useCssAnchor) {
        positionPopoverCssAnchor(trigger);
    }
    else {
        positionPopoverJs(trigger);
    }
}
function hidePopover() {
    var el = popoverEl;
    if (!el) {
        return;
    }
    if (useCssAnchor && anchoredTriggerEl) {
        var anchorEl_1 = anchoredTriggerEl;
        clearAnchorRemovalTimer();
        anchorRemovalTimer = window.setTimeout(function () {
            anchorRemovalTimer = null;
            anchorEl_1.style.removeProperty('anchor-name');
            if (anchoredTriggerEl === anchorEl_1) {
                anchoredTriggerEl = null;
            }
        }, ANCHOR_NAME_LEAVE_MS);
    }
    el.classList.remove('is-visible', 'glossary-tooltip--below');
    el.style.left = '';
    el.style.top = '';
    el.style.visibility = '';
    el.removeAttribute('data-active-glossary-post-id');
    setTimeout(function () {
        el.setAttribute('hidden', '');
    }, ANCHOR_NAME_LEAVE_MS);
    activeTrigger = null;
    document.querySelectorAll('.glossary-term[aria-expanded="true"]').forEach(function (n) {
        n.setAttribute('aria-expanded', 'false');
        n.removeAttribute('aria-describedby');
    });
}
function showForTrigger(trigger) {
    var _a;
    clearAnchorRemovalTimer();
    var id = trigger.getAttribute('data-glossary-id');
    var g = window.cowpGlossary;
    if (!id || !(g === null || g === void 0 ? void 0 : g.definitions)) {
        return;
    }
    var html = (_a = g.definitions[id]) !== null && _a !== void 0 ? _a : g.definitions[String(id)];
    if (!html) {
        return;
    }
    activeTrigger = trigger;
    var el = getPopover();
    var inner = el.querySelector('.glossary-tooltip__inner');
    if (inner) {
        inner.innerHTML = html;
    }
    trigger.setAttribute('aria-expanded', 'true');
    /** Immer feste ID — sonst überschreibt man `glossary-tooltip-popover` und #glossary-tooltip-popover greift nicht. */
    el.id = 'glossary-tooltip-popover';
    trigger.setAttribute('aria-describedby', 'glossary-tooltip-popover');
    el.setAttribute('data-active-glossary-post-id', id);
    positionPopover(trigger);
}
function scheduleShow(trigger) {
    clearTimers();
    hoverOpenTimer = window.setTimeout(function () {
        showForTrigger(trigger);
        hoverOpenTimer = null;
    }, HOVER_OPEN_MS);
}
function scheduleHide() {
    clearTimers();
    hoverCloseTimer = window.setTimeout(function () {
        hidePopover();
        hoverCloseTimer = null;
    }, HOVER_CLOSE_MS);
}
function bindTerm(el, isCoarse) {
    if (!isCoarse) {
        el.addEventListener('mouseenter', function () { return scheduleShow(el); });
        el.addEventListener('mouseleave', function () { return scheduleHide(); });
    }
    el.addEventListener('focus', function () { return showForTrigger(el); });
    el.addEventListener('blur', function () { return scheduleHide(); });
}
function readTooltipDebugIdFromUrl() {
    try {
        var raw = new URLSearchParams(window.location.search).get(TOOLTIP_DEBUG_PARAM);
        if (raw === null) {
            return null;
        }
        var trimmed = raw.trim();
        return trimmed === '' ? null : trimmed;
    }
    catch (_a) {
        return null;
    }
}
/**
 * Öffnet den Tooltip für die angegebene Glossar-Post-ID (wie nach Hover, ohne Verzögerung).
 */
function openDebugTooltipByGlossaryId(id) {
    var trigger = null;
    var terms = document.querySelectorAll('.glossary-term');
    for (var i = 0; i < terms.length; i++) {
        var el = terms[i];
        if (el.getAttribute('data-glossary-id') === id) {
            trigger = el;
            break;
        }
    }
    if (!trigger) {
        /* eslint-disable-next-line no-console */
        console.warn("[cowp-glossary] Kein .glossary-term mit data-glossary-id=\"".concat(id, "\" (?").concat(TOOLTIP_DEBUG_PARAM, "=\u2026)."));
        return;
    }
    var t = trigger;
    requestAnimationFrame(function () {
        t.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
        requestAnimationFrame(function () {
            showForTrigger(t);
        });
    });
}
function initGlossaryTooltips() {
    var _a;
    if (!((_a = window.cowpGlossary) === null || _a === void 0 ? void 0 : _a.definitions) || Object.keys(window.cowpGlossary.definitions).length === 0) {
        return;
    }
    if (window.__cowpGlossaryTooltipInit) {
        return;
    }
    var termEls = document.querySelectorAll('.glossary-term');
    if (termEls.length === 0) {
        return;
    }
    window.__cowpGlossaryTooltipInit = true;
    var isCoarse = window.matchMedia('(pointer: coarse)').matches;
    termEls.forEach(function (node) {
        bindTerm(node, isCoarse);
    });
    var debugTooltipId = readTooltipDebugIdFromUrl();
    if (debugTooltipId !== null) {
        openDebugTooltipByGlossaryId(debugTooltipId);
    }
    if (useCssAnchor) {
        getPopover();
    }
    if (isCoarse) {
        document.addEventListener('click', function (e) {
            var _a, _b;
            var t = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, '.glossary-term');
            if (t) {
                e.preventDefault();
                if (activeTrigger === t && (popoverEl === null || popoverEl === void 0 ? void 0 : popoverEl.classList.contains('is-visible'))) {
                    hidePopover();
                }
                else {
                    showForTrigger(t);
                }
            }
            else if (popoverEl && !popoverEl.contains(e.target)) {
                hidePopover();
            }
        });
    }
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            hidePopover();
        }
    });
    window.addEventListener('scroll', function () {
        if (!activeTrigger || !(popoverEl === null || popoverEl === void 0 ? void 0 : popoverEl.classList.contains('is-visible'))) {
            return;
        }
        if (!useCssAnchor) {
            positionPopoverJs(activeTrigger);
        }
    }, true);
    window.addEventListener('resize', function () {
        if (!activeTrigger || !(popoverEl === null || popoverEl === void 0 ? void 0 : popoverEl.classList.contains('is-visible'))) {
            return;
        }
        if (!useCssAnchor) {
            positionPopoverJs(activeTrigger);
        }
    });
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlossaryTooltips);
}
else {
    initGlossaryTooltips();
}
export {};
